import update from 'immutability-helper'
import clsx from 'clsx'
import React from 'react'
import Box from '@mui/material/Box'
import useStyles from './styles'

export default function PreviewFillInTheBlanksQuestion ({index, context, question}) {

  const classes = useStyles()
  const [phrases, setPhrases] = React.useState([])

  React.useEffect(() => {
    const {phrases = []} = question.answer
    setPhrases(phrases)
  }, [question.answer])

  function handlePhraseChange (index, phrase) {
    setPhrases(update(phrases, {[index]: {phrase: {$set: phrase}}}))
  }
	
  return (
    <Box className={clsx(classes.root, "question", "fill-in-the-blanks")}>
      {phrases.map(({phrase, blanked}, index) =>
        blanked
          ? (<input
            key={index}
            className={clsx("phrase", "input")}
            type="text"
            value={phrase}
            onChange={e => handlePhraseChange(index, e.target.value)}
            />)
          : (<Box
            key={index}
            className={clsx("phrase", "word")}>{phrase}</Box>)
      )}
  </Box>)
}
